// React imports
import React, { Component } from "react";
import { connect } from "react-redux";

// React Admin imports
import { Notification, setSidebarVisibility } from "react-admin";

import { createMuiTheme, MuiThemeProvider, withStyles } from "@material-ui/core/styles";

// Other imports
import AppBar from "../partials/AppBar";
import Sidebar from "../partials/Sidebar";
import Menu from "../partials/Menu";
import LibraryTranslations from "../../i18n/LibraryTranslations";
import COLORS from "../colors";
import Theme from "../Theme";

// react-admin only applies its theme prop in its own Layout, not a custom one
const theme = createMuiTheme(Theme);

/* const CustomSidebar = props => <Sidebar size={240} {...props} />;
const CustomLayout = props => (
    <Layout appBar={AppBar} sidebar={CustomSidebar} {...props} />
); */

const styles = theme => ({
  root: {
    display: "flex",
    flexDirection: "column",
    zIndex: 1,
    minHeight: "100vh",
    backgroundColor: COLORS.field,
    position: "relative"
  },
  appFrame: {
    display: "flex",
    flexDirection: "column",
    overflowX: "auto"
  },
  contentWithSidebar: {
    display: "flex",
    flexGrow: 1
  },
  content: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 2,
    minWidth: 0,
    padding: 24,
    marginTop: "0"
  },
  pageTitle: {
    margin: "0 0 16px",
    color: COLORS.text,
    fontFamily: theme.typography.fontFamily,
    fontSize: 24,
    fontWeight: 700,
    "&:empty": {
      display: "none"
    }
  }
});

class CustomLayout extends Component {
  componentWillMount() {
    this.props.setSidebarVisibility(true);
  }

  render() {
    const { children, classes, dashboard, logout, open, title } = this.props;

    return (
      <LibraryTranslations>
        <MuiThemeProvider theme={theme}>
          <div className={classes.root} notification={Notification}>
            <AppBar title={title} open={open} logout={logout} />
            <main className={classes.contentWithSidebar}>
              <Sidebar>
                <Menu logout={logout} hasDashboard={!!dashboard} />
              </Sidebar>
              <div className={classes.content}>
                <h1 id="react-admin-title" className={classes.pageTitle} />
                {children}
              </div>
            </main>
            <Notification />
          </div>
        </MuiThemeProvider>
      </LibraryTranslations>
    );
  }
}

const mapStateToProps = state => ({ isLoading: state.admin.loading > 0 });
export default connect(
  mapStateToProps,
  { setSidebarVisibility }
)(withStyles(styles)(CustomLayout));
